<app-toast-host></app-toast-host>
<app-audio-host></app-audio-host>
<div class="app-container">
    <app-top-bar *ngIf="userSettings.isSettingsLoaded()"></app-top-bar>
    <app-system-alert-banner *ngIf="userSettings.isSettingsLoaded()"></app-system-alert-banner>
    <div class="app-body">
        <app-side-bar class="side-bar"></app-side-bar>
        <div class="router-window">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>